import {
    CADRAGE_AMOUNT_FIELD,
    IS_PHASE_ACTIVE,
    Phase,
    ARE_PROJECTIONS_AVAILABLE,
    BudgetPhases,
} from 'business/constants';
import { cadragePhase } from './budgetPhases/cadrage';
import { supplementaryPhase } from './budgetPhases/supplementary';
import { arbitragePhase } from './budgetPhases/arbitrage';
import { propositionPhase } from './budgetPhases/proposition';
import { votePhase } from './budgetPhases/vote';
import { archivedPhase } from './budgetPhases/archived';
import { getColnameValueByYear } from 'routes/BudgetModule/helpers/format';
import { InscriptionT } from '../entities/inscription';
import { arbitrageDMPhase } from 'routes/BudgetModule/shared/phases/budgetPhases/arbitrageDM';
import { IS_REJECTED } from 'routes/BudgetModule/config/constants';

const {
    PROPOSITION_SERVICES,
    VOTE,
    CADRAGE,
    SUPPLEMENTARY_BUDGET,
    ARBITRAGE_DM,
    ARBITRAGE,
    ARCHIVED,
} = BudgetPhases;

export type PhaseHelpers = {
    getPhaseHeaderName: (exercice: number, t?: TranslationT) => string;
};

export const BUDGET_PHASES = {
    [ARBITRAGE]: arbitragePhase,
    [ARCHIVED]: archivedPhase,
    [CADRAGE]: cadragePhase,
    [PROPOSITION_SERVICES]: propositionPhase,
    [SUPPLEMENTARY_BUDGET]: supplementaryPhase,
    [ARBITRAGE_DM]: arbitrageDMPhase,
    [VOTE]: votePhase,
};

/**
 * Get the phase settings for a given phase name.
 */
export const getPhaseSettings = (
    phases: Phase[],
    phase: BudgetPhases,
): Phase | undefined => {
    return phases.find((p) => p.name === phase);
};

/**
 * Get the cadrage metric by year for a given phase.
 */
export const getMetricByYear = (
    phaseSettings: Phase | undefined,
    year: number,
) => {
    if (phaseSettings === undefined) {
        return '';
    }
    const amountField = phaseSettings[CADRAGE_AMOUNT_FIELD];
    return phaseSettings[IS_PHASE_ACTIVE]
        ? amountField
        : getColnameValueByYear(amountField, year);
};

export const getPhaseProjectionsAvailable = (
    phasesSettings: Phase[] | undefined,
    phase: BudgetPhases,
): boolean => {
    if (phasesSettings === undefined) {
        return false;
    }

    const phaseSettings = getPhaseSettings(phasesSettings, phase);
    return phaseSettings?.[ARE_PROJECTIONS_AVAILABLE] ?? false;
};

/**
 * Check if an inscription is rejected for a specific phase.
 */
export const isRejectedForPhase = (
    inscription: InscriptionT,
    phase?: BudgetPhases,
) => {
    if (phase === undefined || inscription.phases === undefined) {
        // We take the IS_REJECTED field from the inscription root : which is calculated in backend with current inscription.BP phase.
        return inscription[IS_REJECTED];
    }
    const targetPhasedInscription = inscription.phases.find(
        (phasedInscription) => phasedInscription.phase === phase,
    );
    return targetPhasedInscription?.[IS_REJECTED] ?? false;
};
